import { render, staticRenderFns } from "./ContentDash.vue?vue&type=template&id=0dcd940e&scoped=true"
import script from "./ContentDash.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentDash.vue?vue&type=style&index=0&id=0dcd940e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd940e",
  null
  
)

export default component.exports